import {componentConfig, componentLoader} from "../../lib/component_initializer";
import {PopoverConfig, Popover} from "./popover"

export const popoverLoader = function(options={}){
    componentLoader(componentConfig(Popover, PopoverConfig.componentTypeKey, PopoverConfig.baseHtmlClass), options);
};
